export default __webpack_public_path__ + "static/media/elevator.7e16cc12.svg";